import React from "react";
import { useDispatch } from "react-redux";
import { Typography } from "@material-ui/core";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getFileExtension } from "@icarius-utils/fileUpload";
import { getLocalizedString } from "@icarius-localization/strings";

const FileInput = (props) => {

  const {
    id, // para pantallas con mas de un input, cada input con id distinto arregla bug
    acceptedFormats,
    label,
    helperText,
    handleChange,
    multiple,
    disabled,
    preSubmitCallback,
    required,
  } = props;

  const dispatch = useDispatch();

  const filesAreValid = (files) => files.every((file) => acceptedFormats.includes(`.${getFileExtension(file.name)}`.toLowerCase()));

  const submitFiles = (event) => {
    preSubmitCallback && preSubmitCallback();

    const fileArray = Array.from(event.target.files);
    event.target.value = '';

    if (!filesAreValid(fileArray)) {
      dispatch(openSnackbarAction({
        msg: getLocalizedString("wrongFormatFiles"),
        severity: "error",
      }));
      return;
    }

    handleChange(fileArray);
  }

  const inputId = id || 'fileInput';

  return (
    <div>
      <input
        disabled={disabled}
        type="file"
        id={inputId}
        style={{ display: "none" }}
        multiple={multiple}
        onChange={(e) => submitFiles(e)}
        accept={acceptedFormats.join(',')}
      />
      <label htmlFor={inputId} style={{ display: "flex", gap: 5 }}>
        <Typography
          className="whiteText"
          style={{
            textDecoration: disabled ? "" : "underline",
            cursor: disabled ? "" : "pointer",
          }}
        >
          {label || getLocalizedString("selectFiles")}
        </Typography>
        {
          required &&
          <Typography className="errorColor">
            {'*'}
          </Typography>
        }
      </label>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {
          helperText &&
          <Typography className="whiteText" variant="caption">
            {helperText}
          </Typography>
        }
        <Typography className="whiteText" variant="caption">
          {`${getLocalizedString("validFormats")}: ${acceptedFormats.join(', ')}`}
        </Typography>
      </div>
    </div>
  )
}

export default FileInput;
